export enum CPImageAlignment {
    Right = 0,
    Left = 1,
    Above = 2,
    Middle = 3,
    Below = 4
}